export const genereateSessionIdOrder = () => {
    return `session_${Math.random().toString(36).substring(2, 9)}`
}